import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux'

import { Alert } from 'antd';



class HelpAlert extends Component {

    static propTypes = {
        session: PropTypes.object.isRequired,
    }

    render() {
        let props = {...this.props}
        // Format message
        if (props.message && typeof props.message === 'string') {
            props.message = <FormattedMessage id={props.message} />
        }
        // Format description
        if (props.description && typeof props.description === 'string') {
            props.description = <FormattedMessage id={props.description} />
        }
        // Set default props
        props.type = props.type || "info"
        props.closable = props.closable !== undefined ? props.closable : true
        props.showIcon = props.showIcon !== undefined ? props.showIcon : true
        // Return alert or null
        return this.props.session.user.showHelp ? <Alert {...props} /> : null
    }

}

const mapStateToProps = (state, ownProps) => ({
    session: state.session
})

export default connect(mapStateToProps)(HelpAlert)


// WEBPACK FOOTER //
// ./src/components/HelpAlert.js